// ATG custom lettering landing — membership plans (duplicate implementation for ATG theme bundle)
(function () {
    var storefrontApp = angular.module("storefrontApp");

    storefrontApp.controller("atgCustomLetteringPlansController", [
        "$scope",
        "$http",
        "$window",
        "atgLetteringSubscriptionService",
        function ($scope, $http, $window, atgLetteringSubscriptionService) {
            $scope.membershipPlans = [];

            /** Highlight row when API returns this planId (set via storefront env if needed). */
            $scope.membershipPlanHighlightId =
                typeof window !== "undefined" &&
                window.__env &&
                window.__env.atgCustomLetteringHighlightPlanId
                    ? window.__env.atgCustomLetteringHighlightPlanId
                    : "";

            $scope.customerSubscription = {
                plans: [],
                recurringPlans: [],
                nonRecurringPlans: [],
            };

            $scope.pricing = {
                isLoading: true,
            };

            function shouldHidePlan(plan) {
                if (!plan) return false;

                if (plan.credits === 20 || plan.credits === 40) return true;

                var name = (plan.name || plan.displayName || "").toString().toLowerCase();
                if (name.indexOf("20 credits") !== -1) return true;
                if (name.indexOf("40 credits") !== -1) return true;

                return false;
            }

            atgLetteringSubscriptionService.getSubscriptionPlans().then(
                function (res) {
                    var plans = res && res.data ? res.data : [];
                    plans = plans.filter(function (p) {
                        return !shouldHidePlan(p);
                    });
                    $scope.customerSubscription.plans = plans;
                    $scope.customerSubscription.recurringPlans = plans.filter(function (p) {
                        return !!p.isRecurring;
                    });
                    $scope.customerSubscription.nonRecurringPlans = plans.filter(function (p) {
                        return !p.isRecurring;
                    });
                    $scope.pricing.isLoading = false;
                },
                function () {
                    $scope.pricing.isLoading = false;
                }
            );

            $scope.getMembershipPlans = function () {
                return $http.get("storefrontapi/club/membershipplans").then(
                    function (response) {
                        var plans = response && response.data ? response.data : [];
                        $scope.membershipPlans = plans.filter(function (plan) {
                            if (!plan || !plan.planId) return false;
                            return plan.planId !== "ED-Trial" && plan.planId !== "ATG-Trial";
                        });
                    },
                    function () {
                        $scope.membershipPlans = [];
                    }
                );
            };

            $scope.buyPlan = function (plan) {
                if (!plan || !plan.planId) return;

                var url = "/customersubscription/checkout/" + plan.planId;

                if (!plan.isRecurring) {
                    var credits = plan.credits || 1;
                    url += "?credits=" + credits;
                }

                $window.location.href = url;
            };

            $scope.getMembershipPlans();
        },
    ]);
})();
